<template>
    <div id="userdetail-page" class="mb-5">
        <b-card>
            <b-row>
              <b-col md="12">
              <h3>{{$route.name}}</h3>
              <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/company-structure/company">Company</router-link></b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
              </b-breadcrumb>
              <div class="border-bottom"></div>
             </b-col>
            </b-row>
            <form v-on:submit.prevent="doSubmit" class="mt-2">
              <b-row>
                <b-col md="12">
                  <b-row>
                    <b-col md="5">
                      <label class="labels">name *</label>
                      <div class="form-group" v-bind:class="errors.has('name') ? 'has-error':''">
                        <input type="text" class="form-control" v-bind:class="errors.has('name') ? 'is-invalid':''" v-validate="'required'" data-vv-as="name" name="name" v-model="model.name" placeholder="Name" />
                        <p v-if="errors.has('name') !== null"></p>
                      </div>
                    </b-col>
                    <b-col md="2">
                    </b-col>
                    <b-col md="5">
                      <label class="labels">registration id *</label>
                      <div class="form-group" v-bind:class="errors.has('registrationId') ? 'has-error':''">
                        <input type="text" class="form-control" v-bind:class="errors.has('registrationId') ? 'is-invalid':''" v-validate="'required'" data-vv-as="registrationId" name="registrationId" v-model="model.registrationId" placeholder="Registration ID" />
                        <p v-if="errors.has('registrationId') !== null"></p>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="5">
                      <label class="labels">Business Sector *</label>
                      <b-form-select name="businessSector" v-model="model.businessSector" v-bind:class="errors.has('businessSector') ? 'is-invalid':''" v-validate="modelValidations.businessSector" :error="errors.first('businessSector')" :options="businessSectorList" />
                        <template v-slot:first>
                          <b-form-select-option :value="null" disabled>Please Select Business Sector</b-form-select-option>
                        </template>
                    </b-col>
                    <b-col md="2">
                      <label class="labels"></label>
                      <b-button variant="primary" class="btn-custom" @click="showModalBusiness()" style="margin-left:-22px!important; margin-top:1.8em!important;"><font-awesome-icon icon="plus"/></b-button>
                    </b-col>
                    <b-col md="5">
                      <label class="labels">Photo</label>
                      <b-form-file :required="false" label="Photo">
                      </b-form-file>
                      <!-- <div class="mt-3">Selected file: {{ model.path ? model.path : '' }}</div> -->
                        <!-- <div class="input-group" v-else>
                          <div class="custom-file">
                            <b-form-input type="file" class="custom-file-input" @change="onFileSelectedPath" ref="path" id="pathinputGroupFile" accept="image/*" name="path" :src="model.path" :error="errors.first('path')" data-vv-as="path 3"/>
                            <label class="custom-file-label" for="pathinputGroupFile">{{model.path !== null ? model.path : 'No file chosen'}}</label>
                          </div>
                          <div v-if="model.path !== null" class="input-group-append">
                            <span class="input-group-text bg-danger text-white pointer" title="Clear Image" @click="clearImagePath"><font-awesome-icon icon="times"/></span>
                          </div>
                        </div> -->
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="5 mt-3">
                      <label class="labels">email *</label>
                      <div class="form-group" v-bind:class="errors.has('email') ? 'has-error':''">
                        <input type="email" class="form-control" v-bind:class="errors.has('email') ? 'is-invalid':''" v-validate="'required'" data-vv-as="email" name="email" v-model="model.email" placeholder="Ex: myname@example.com" />
                        <p v-if="errors.has('email') !== null"></p>
                      </div>
                    </b-col>
                    <b-col md="2">
                    </b-col>
                    <b-col md="5 mt-3">
                      <label class="labels">tax id *</label>
                      <div class="form-group" v-bind:class="errors.has('taxId') ? 'has-error':''">
                        <input type="number" class="form-control" v-bind:class="errors.has('taxId') ? 'is-invalid':''" v-validate="'required'" data-vv-as="taxId" name="taxId" v-model="model.taxId" placeholder="Tax ID" />
                        <p v-if="errors.has('taxId') !== null"></p>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="5">
                      <label class="labels">Telephone *</label>
                      <div class="form-group" v-bind:class="errors.has('phone') ? 'has-error':''">
                        <input type="number" class="form-control" v-bind:class="errors.has('phone') ? 'is-invalid':''" v-validate="'required'" data-vv-as="phone" name="phone" v-model="model.phone" placeholder="Telephone" />
                        <p v-if="errors.has('phone') !== null"></p>
                      </div>
                      <!--<label class="labels">email</label>
                      <div class="form-group" v-bind:class="errors.has('email') ? 'has-error':''">
                        <input type="email" class="form-control mr-1" v-bind:class="errors.has('email') ? 'is-invalid':''" v-validate="'required'" data-vv-as="email" name="email" v-model="model.email" placeholder="Email" />
                        <p v-if="errors.has('email') !== null" class="invalid-feedback">{{errors.first('email')}}</p>
                      </div>-->
                    </b-col>
                    <b-col md="1">
                      <div class="form-group" v-bind:class="errors.has('extPhone') ? 'has-error':''">
                        <input type="number" class="form-control label-ext" data-vv-as="extPhone" name="extPhone" v-model="model.extPhone" placeholder="Ext" />
                      </div>
                    </b-col>
                    <b-col md="1">
                    </b-col>
                    <b-col md="5">
                      <label class="labels">fax *</label>
                      <div class="form-group" v-bind:class="errors.has('fax') ? 'has-error':''">
                        <input type="number" class="form-control" v-bind:class="errors.has('fax') ? 'is-invalid':''" v-validate="'required'" data-vv-as="fax" name="fax" v-model="model.fax" placeholder="Fax" />
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="5">
                      <label class="labels">address *</label>
                      <div class="form-group" v-bind:class="errors.has('address') ? 'has-error':''">
                        <b-form-textarea rows="3" class="form-control" v-bind:class="errors.has('address') ? 'is-invalid':''" v-validate="'required'" data-vv-as="address" name="address" v-model="model.address" placeholder="Address" />
                        <p v-if="errors.has('address') !== null"></p>
                      </div>
                    </b-col>
                    <b-col md="2">
                    </b-col>
                    <b-col md="5">
                      <label class="labels">about company</label>
                      <div class="form-group" v-bind:class="errors.has('about') ? 'has-error':''">
                        <b-form-textarea rows="3" class="form-control" v-bind:class="errors.has('about') ? 'is-invalid':''" data-vv-as="about" name="about" v-model="model.about" placeholder="About Company" />
                        <p v-if="errors.has('about') !== null"></p>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <div class="mt-4">
                <b-button class="mr-2" @click="goBack" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
                <b-button :variant="$route.params.id !== undefined ? 'warning' : 'primary'" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{$route.params.id !== undefined ? 'Update' : 'Save'}} </b-button>
              </div>
            </form>
            <b-modal id="bv-modal" hide-footer>
              <template v-slot:modal-title>
                <h5 class="text-transform">Add Business Sector</h5>
              </template>
              <form v-on:submit.prevent="doAddDataBusiness()">
                <div class="d-block">
                  <label for=""><strong>Name *</strong></label>
                  <b-form-input v-model="formData.name" required placeholder="Enter Name"></b-form-input><br>
                  <label for=""><strong>Note</strong></label>
                  <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter Note"></b-form-textarea>
                </div>
                <b-button class="mt-4" @click="$bvModal.hide('bv-modal')"><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button>
                <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="save"></font-awesome-icon> Submit</b-button>
              </form>
            </b-modal>
        </b-card>
    </div>
</template>

<script>
  export default {
    name: 'company-form',
    data () {
      return {
        isLoading: false,
        apiUrl: {
          company: window.AppConfig.apiUrl + 'company',
        },
        model: {
          // idCompany: '',
          name: '',
          registrationId: '',
          businessSector: '',
          path: null,
          taxId: '',
          address: '',
          phone: '',
          extPhone: '',
          fax: '',
          email: '',
          about: '',
        },
        businessSectorList: [
          {
            value: '',
            text: 'Please Select Business Sector'
          }
        ],
        modelValidations: {
          businessSector: {
            required: true
          },
          path: {
            required: true
          }
        },
        formData: {
          name: '',
          note: ''
        },
      }
    },
    mounted () {
      this.initData()
      this.getBusinessSector()
      // this.initCompanyList()
    },
    methods: {
      initData() {
        if (this.$route.params.id !== undefined){
          this.getDetail()
        }
      },
      getDetail () {
          this.isLoading = true
          this.$http.get(this.apiUrl.company + '/' + this.$route.params.id).then(response => {
          // this.model.idCompany = response.data.idCompany !== null ? response.data.idCompany : '-'
          this.model.name = response.data.name !== null ? response.data.name : '-'
          this.model.businessSector = response.data.businessSector !== null && response.data.businessSector !== '' && response.data.businessSector !== 'null' && response.data.businessSector !== undefined ? response.data.businessSector.uuid : null
          this.model.address = response.data.address !== null ? response.data.address : '-'
          this.model.phone = response.data.phone !== null ? response.data.phone : '-'
          this.model.extPhone = response.data.extPhone !== null ? response.data.extPhone : '-'
          this.model.fax = response.data.fax !== null ? response.data.fax : '-'
          // this.model.path = response.data.path !== null ? response.data.path : null
          this.model.registrationId = response.data.registrationId !== null ? response.data.registrationId : '-'
          this.model.taxId = response.data.taxId !== null ? response.data.taxId : '-'
          this.model.email = response.data.email !== null ? response.data.email : '-'
          this.model.about = response.data.about !== null ? response.data.about : '-'
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
        })
      },
      onFileSelectedPath (event) {
        this.model.path = event.target.files[0]
      },
      clearImagePath () {
        this.$refs.path.value = ''
        this.model.path = null
      },
      getBusinessSector () {
        this.$http.get(window.AppConfig.apiUrl + 'business-sector?limit=1000').then(resp => {
          this.businessSectorList = [
            {
              value: '',
              text: 'Please Select Business Sector'
            }
          ]
          resp.data._embedded.business_sector.forEach(data => {
            this.businessSectorList.push({
              value: data.uuid,
              text: data.name
            })
          })
        })
      },
      showModalBusiness () {
        this.formData.name = null
        this.formData.note = null
        this.$bvModal.show('bv-modal')
      },
      doAddDataBusiness () {
        this.isLoading = true
        this.$http.post(window.AppConfig.apiUrl + 'business-sector', {
          name: this.formData.name,
          note: this.formData.note
        })
        .then((resp) => {
          this.isLoading = false
          this.formData.name = null
          this.formData.note = null
          this.getBusinessSector()
          this.$bvModal.hide('bv-modal')
          this.$store.dispatch('notification/success', 'Business Sector has been added')
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
        });
      },
      getDateTime (value) {
        if (value !== null) {
          return this.$moment(value).format('YYYY-MM-DD HH:mm A')
        } else {
          return '-'
        }
      },
      goBack () {
        window.goBack(this)
      },
      getStatusColor (val) {
        switch (parseInt(val)) {
        case 0:
          return 'success'
          break
        case 1:
          return 'info'
          break
        }
      },
      doSubmit () {
        this.$validator.validateAll().then(res => {
          if (res) {
            let formData = new FormData()
            formData.append('name', this.model.name)
            formData.append('registrationId', this.model.registrationId)
            formData.append('email', this.model.email)
            formData.append('businessSector', this.model.businessSector)
            formData.append('phone', this.model.phone)
            formData.append('taxId', this.model.taxId)
            // formData.append('photo', this.model.path)
            // if (this.model.path !== null) {
            //   formData.append('photo', this.model.path)
            // }
            formData.append('address', this.model.address)
            formData.append('fax', this.model.fax)
            formData.append('about', this.model.about)
            if (this.$route.params.id !== undefined) {
              this.$http.patch(this.apiUrl.company + '/' + this.$route.params.id, formData).then(response => {
                this.$store.dispatch('notification/success', 'Company has been updated.')
                window.location.href = document.URL.replace('/edit', '')
              }).catch(error => {
                this.$store.dispatch('notification/error', error)
              })
            } else {
              this.$http.post(this.apiUrl.company, formData).then(response => {
                this.$store.dispatch('notification/success', 'Company has been added.')
                window.location.href = document.URL.replace('/create', '/' + response.data.uuid)
              }).catch(error => {
                this.$store.dispatch('notification/error', error)
              })
            }
          } else {
            swal("", "Please fill the required fields!", "info", {
              buttons: false,
              timer: 2000
            });
          }
        })
      },
      // doSubmit () {
      //   this.$validator.validateAll().then(res => {
      //     if (res) {
      //       if (this.$route.params.id !== undefined) {
      //         this.$http.patch(this.apiUrl.company + '/' + this.$route.params.id, this.model).then(response => {
      //           this.$store.dispatch('notification/success', 'Company has been updated.')
      //           window.location.href = document.URL.replace('/edit', '')
      //         }).catch(error => {
      //           this.$store.dispatch('notification/error', error)
      //         })
      //       } else {
      //         this.$http.post(this.apiUrl.company, this.model).then(response => {
      //           this.$store.dispatch('notification/success', 'Company has been added.')
      //           window.location.href = document.URL.replace('/create', '/' + response.data.uuid)
      //         }).catch(error => {
      //           this.$store.dispatch('notification/error', error)
      //         })
      //       }
      //     } else {
      //       swal("", "Please fill the required fields!", "info", {
      //         buttons: false,
      //         timer: 2000
      //       });
      //     }
      //   })
      // },
    }
  }
</script>